import React, { useRef, useMemo, useEffect, useState } from "react";
import firebase from "../utils/firebase";
import Card from "../components/card";
import { FirestoreCollection } from "@react-firebase/firestore";
import {
  Flex,
  Heading,
  Button,
  Grid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Input,
} from "@chakra-ui/react";

function Serve() {
  const descriptionRef = useRef();
  const regionRef = useRef();
  const urlRef = useRef();
  const [wishlists, setWishLists] = useState([]);
  const [isLoggedIn, setLoggedIn] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const getAllPosts = async () => {
    const firebaseFirestore = firebase.firestore();
    const querySnapshot = await firebaseFirestore.collection("wishlist").get();
    const docs = querySnapshot.docs.map((doc) => doc.data());
    setWishLists(docs);
  };

  const createPost = async () => {
    const firebaseFirestore = firebase.firestore();
    const response = await firebaseFirestore.collection("wishlist").add({
      region: regionRef.current.value,
      amazon_url: urlRef.current.value,
      description: descriptionRef.current.value,
    });
    onClose();
    console.log("Done");
  };

  useEffect(() => {
    getAllPosts();
    firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        setLoggedIn(true);
      }
    });
  }, []);

  return (
    <>
      <Flex direction="column" mt={120}>
        <Flex justify="space-between" p={10}>
          <Heading> Help Serve Girls and Women Around the World </Heading>
          {isLoggedIn ? (
            <Button onClick={onOpen} variant="outline">
              Create a WishList
            </Button>
          ) : (
            <></>
          )}
        </Flex>
        <Grid gridTemplateColumns="1fr 1fr 1fr" gridGap={4} p={10}>
          <FirestoreCollection path="/wishlist/">
            {(wishlists) => {
              if (wishlists.isLoading) {
                return <></>;
              } else {
                return wishlists.value.map((item, index) => {
                  return (
                    <Card
                      key={index}
                      region={item.region}
                      description={item.description}
                      amazon_url={item.amazon_url}
                    />
                  );
                });
              }
            }}
          </FirestoreCollection>
        </Grid>
      </Flex>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Create a post for your wishlist</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl id="description">
              <FormLabel>Description</FormLabel>
              <Input type="text" ref={descriptionRef} />
              <FormHelperText>
                Describe a summary of what is in your wishlist! Ex. 2 Packs of
                Pads
              </FormHelperText>
            </FormControl>

            <FormControl id="region" mt={4}>
              <FormLabel>Region</FormLabel>
              <Input type="text" ref={regionRef} />
              <FormHelperText>For example: Hong Kong</FormHelperText>
            </FormControl>

            <FormControl id="url" mt={4}>
              <FormLabel>Link your wishlist </FormLabel>
              <Input type="url" ref={urlRef} />
              <FormHelperText>
                Copy your wishlist link from Amazon and paste it here so people
                can help fullfill it!
              </FormHelperText>
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Close
            </Button>
            <Button colorScheme="pink" onClick={createPost}>
              Submit
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default Serve;
